

export interface SystemSettingsState {
  systemSettings: SystemSettingItem[],
  systemSettingItem?: SystemSettingItem
}

export interface SystemSettingItem {
  id?: number,
  name: string,
  value: string,
  description: string
}

export interface SystemSettingFilter {
  name?: string,
}

export class SystemSettingFilterImpl implements SystemSettingFilter {
  name?: string = undefined;
}